<template>
    <div class="flex-grow-1">
        <filter-label
            v-for="item in items"
            v-bind="item"
            :key="item.name + item.value"
            @remove="onRemove"
        ></filter-label>
    </div>
</template>

<script>
    import Label from "./label";

    export default {
        props: {
            items: Array
        },

        methods: {
            onRemove(e) {
                this.$emit('filter-remove', e);
            }
        },

        components: {
            FilterLabel: Label,
        },
    }
</script>
